// extracted by mini-css-extract-plugin
export var content = "_4i-3";
export var list = "_4i-4";
export var settingsContent = "_4i-7";
export var settingsPanel = "_4i-8";
export var state = "_4i-6";
export var triggerBadge = "_4i-2";
export var triggerButton = "_4i-1";
export var triggerShell = "_4i-0";
export var unreadDot = "_4i-5";